var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelephoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.242,
    height: 26,
    viewBox: "0 0 24.242 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(-131.792 -55.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M140.9,63.181c1.444-1.676-.125-3.881-1.091-5.382-.547-.87-1.349-2.1-2.482-2.262-1.072-.114-2.045,1.08-2.756,1.733a8.236,8.236,0,0,0-2.756,5.876c.011.262.011.692-.027.3a17.087,17.087,0,0,0,.817,4.006,17.2,17.2,0,0,0,1.775,3.474,32.005,32.005,0,0,0,5.39,6.382,15.907,15.907,0,0,0,7.062,4.029,8.253,8.253,0,0,0,7.066-1.676c.726-.6,2.072-1.463,2.129-2.493a3.389,3.389,0,0,0-1.482-2.5c-1.52-1.361-3.755-3.619-5.823-1.969-.8.661-1.657,1.881-2.737,2.053-1.064.179-2.1-.6-2.874-1.213a17.552,17.552,0,0,1-4.44-5.329,2.916,2.916,0,0,1-.182-2.927C139.139,64.412,140.211,64,140.9,63.181Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneIcon);
export default __webpack_public_path__ + "static/media/telephoneIcon.0508473ff57065453753794783b191f5.svg";
export { ForwardRef as ReactComponent };